<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <img :src="imagePrefix + type.posterTop" width="100%" alt="" />
    <div class="main margin-t margin-b">
      <div v-if="list.length > 0" class="width-100 margin-b flex-row justify-content-spaceBetween align-items-center">
        <div class="width-10 textAlign-r">
          <span class="bg-red fs-big white fw-mid textPadding br-reg">专题<br />热点</span>
        </div>
        <div class="width-90 pointer" @click="newsDetail(list[0].id, 'project')">
          <p class="fs-sBig fw-mid width-100 textAlign-c lineHeight2">{{ list[0].title }}</p>
          <p class="fs-mid darkgrey width-100 textAlign-c">{{ list[0].summary }}</p>
        </div>
      </div>
      <!--      第一部分-->
      <div class="width-100 titBox textAlign-c fs-sBig">
        <img class="" src="@/assets/image/tit.jpg" width="100%" alt="" />
        <div class="flex-row justify-content-center align-items-center width-100 position_relative zIndex top65">
          <span class="red fw-mid fs-superBig">{{ type.typeName }}</span>
          <!--          <p class="fs-superBig fw-mid">标题</p>-->
        </div>
      </div>
      <el-empty v-if="list.length === 0" description="本专题暂无内容。。。"></el-empty>
      <div v-else class="width-100 flex-row justify-content-spaceBetween align-items-star flex-wrap">
        <div
          @click="newsDetail(item.id, 'project')"
          v-for="(item, index) in list"
          :key="index"
          class="width-50 margin-bs flex-row justify-content-start align-items-star pointer"
        >
          <van-image :src="imagePrefix + item.poster" width="30%" class="height120" alt="" />
          <div class="width-60 rightBox paddingLr90 flex-column justify-content-spaceBetween align-items-star">
            <p class="fs-big lineHeight2 fw-mid cutText3">{{ item.title }}</p>
            <p class="fs-mid width-100 textAlign-r grey">
              <van-icon color="#cccccc" class="margin-rs" name="clock" />{{ item.createTime.substring(0, 10) }}
            </p>
          </div>
        </div>
      </div>
      <!--      第二部分-->
      <div class="width-100 titBox textAlign-c fs-sBig margin-t">
        <img class="" src="@/assets/image/tit.jpg" width="100%" alt="" />
        <div class="flex-row justify-content-center align-items-center width-100 position_relative zIndex top65">
          <!--          <span class="red fw-mid fs-superBig">栏目</span>-->
          <p class="fs-superBig fw-mid">{{ type.typeName }}</p>
        </div>
      </div>
      <div class="width-100 flex-row justify-content-spaceBetween align-items-star flex-wrap">
        <div
          @click="newsDetail(item.id, 'project')"
          v-for="item in listWithoutPoster"
          :key="item.index"
          class="width-50 margin-bs flex-row justify-content-start align-items-center pointer"
        >
          <span class="fs-sml">■</span>
          <p class="fs-mid margin-ls width-95 lineHeight2 cutText border-b">{{ item.title }}</p>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import newsApi from '@/api/newsApi';
import config from '@/config';
import Footer from '@/components/footer';
export default {
  name: 'project',
  components: { Footer },
  data() {
    return {
      imagePrefix: config.IMAGE_PREFIX,
      currentPage: 1,
      type: {},
      typeName: '',
      list: [],
      listWithoutPoster: []
    };
  },
  mounted() {},
  created() {
    newsApi
      .oneType(this.$route.query.id)
      .then((res) => {
        this.type = res.data;
        document.title = this.type.typeName;
      })
      .catch((err) => {
        console.log(err);
      });
    newsApi
      .list({ status: '1', type: this.$route.query.id, params: { pageNum: 1, pageSize: 6 } })
      .then((res) => {
        this.list = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
    newsApi
      .list({ status: '1', type: this.$route.query.id, params: { pageNum: 2, pageSize: 6 } })
      .then((res) => {
        this.listWithoutPoster = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    },
    newsDetail(id, type) {
      let text = this.$router.resolve({ path: '/newsDetail', query: { type: type, newsId: id } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    },
    jump(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 0px;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}
.titBox {
  //height: 60px;line-height: 60px;
  background-repeat: no-repeat;
  background-size: cover;
}
.rightBox {
  height: 120px;
}
.border-b {
  border-bottom: 1px #eeeeee dashed;
}
.width-95 {
  width: 95%;
}
.bottomBox {
  background: rgba(0, 0, 0, 0.3);
}
.top65 {
  top: -65px;
}
.height120 {
  height: 120px;
}
</style>
